var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureIcon03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-90%",
    y: "-90%",
    width: "280%",
    height: "280%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.892%",
    y1: ".428%",
    x2: "24.856%",
    y2: "100%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B404C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333843",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.713%",
    y1: "0%",
    x2: "77.754%",
    y2: "68.424%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3039",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A94A7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.028 64.452L.086 77.076l3.95-37.033 27.97-7.364c.1 3.076.27 8.387.512 15.934l15.485 15.72.025.119z",
    fill: "#0270D7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02CBB1",
    d: "M91.767 72.042l2.455-13.396L58.895 70.67 56.44 84.067z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00BFFB",
    d: "M40.783 98.37l6.378-1.937-11.735-12.248-6.379 1.937z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.32,
    fill: "#00BFFB",
    d: "M23.783 14.37l6.378-1.937L18.426.185l-6.379 1.937z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.48,
    fill: "#1D2026",
    filter: "url(#a)",
    d: "M50 43h40v40H50z",
    transform: "translate(-16 -12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.759 16.34a.94.94 0 0 1 .922.399l23.35 40.193c.096.151.143.35.143.545-.001.629-.481 1.21-1.067 1.292l-46.872 6.553a.909.909 0 0 1-.527-.081c-.507-.237-.688-.912-.39-1.5L50.84 16.996c.076-.134.183-.262.307-.372.19-.16.403-.255.612-.283",
    fill: "url(#b)",
    transform: "rotate(27 42.978 77.641)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.338.52c-.01-.006-.022-.01-.033-.017a.893.893 0 0 0-.174-.066c-.01-.002-.022.001-.034-.001a.925.925 0 0 0-.346-.018 1.064 1.064 0 0 0-.315.096l-.004.001c-.06.03-.12.064-.178.105a1.172 1.172 0 0 0-.107.083l-.008.008a1.495 1.495 0 0 0-.295.368L.616 48.344a1.469 1.469 0 0 0-.064.148c-.02.057-.02.113-.033.171-.012.058-.028.116-.033.174-.007.084.002.164.012.246.007.052.006.106.02.156a.99.99 0 0 0 .103.233c.02.037.031.08.056.113a.877.877 0 0 0 .28.25l26.938 14.927a.868.868 0 0 1-.28-.252c-.024-.034-.037-.076-.057-.113-.04-.075-.08-.15-.103-.232-.013-.051-.013-.104-.02-.156-.01-.082-.02-.163-.012-.248.005-.058.021-.115.033-.173.024-.107.046-.216.097-.32L50.78 16.006c.076-.136.18-.265.304-.376.091-.08.19-.142.289-.19a.96.96 0 0 1 .662-.078.95.95 0 0 1 .24.084L25.337.52z",
    transform: "rotate(27 42.028 77.95)",
    fill: "url(#c)",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon03);
export default __webpack_public_path__ + "static/media/feature-icon-03.7591922407c4618bb2c5e85211fa6cee.svg";
export { ForwardRef as ReactComponent };